module.exports = "/_next/static/images/avo-inSar-Slope-failure-def0230273821d0436534faa1d7fae2c.png";